export const CONSENT_KEY = 'da_cookie_consent';
export function getConsent() {
 if(typeof window==='undefined') return null;
 try { const saved=JSON.parse(localStorage.getItem(CONSENT_KEY)); return saved && ['accepted','refused'].includes(saved.value) && saved.expiresAt>Date.now()?saved.value:null; } catch {return null;}
}
export function saveConsent(value) {
 const expires=new Date();expires.setMonth(expires.getMonth()+13);
 try { localStorage.setItem(CONSENT_KEY,JSON.stringify({value,expiresAt:expires.getTime()})); } catch { /* Tracking remains disabled if the choice cannot be saved. */ }
 window.dispatchEvent(new Event('cookie-consent'));
}
